import { isToday, isYesterday, isSameWeek } from "date-fns"

import { capitalize } from "@utils/utils"
import {
    formatToDayAndMonth,
    formatToWeekday,
    formatToHoursAndMinutes,
} from "@utils/datetime-format-utils"

export function getLastDate(date: Date) {
    const timeZoneMinutes = new Date().getTimezoneOffset()
    const dateInUserUtc = new Date(date.getTime() + timeZoneMinutes * 60)
    const isTodayD = isToday(dateInUserUtc)

    if (isTodayD) return formatToHoursAndMinutes(dateInUserUtc)
    else if (isYesterday(dateInUserUtc)) return "Вчера"
    else if (isSameWeek(dateInUserUtc, new Date(), { weekStartsOn: 1 }))
        return capitalize(formatToWeekday(dateInUserUtc))
    else return formatToDayAndMonth(dateInUserUtc)
}
